import { Box, Typography } from "@mui/material";

const TONES = {
  default: "#0f172a",
  green: "#15803d",
  amber: "#b45309",
  red: "#dc2626",
  purple: "#7c3aed",
};

// Totals shown in the bottom bar of a list/report table. Each total is a small
// label over its value, so nothing wraps mid-sentence and the amount is never
// split from its "AED" prefix. items: [{ label, value, tone? }]
export default function ListTotalsFooter({ items = [], note }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        flexWrap: "nowrap",
        flexShrink: 0,
        columnGap: 3,
        rowGap: 0.5,
        px: 1.5,
        py: 0.5,
      }}
    >
      {items.map((it, i) => (
        <Box
          key={it.label}
          onClick={it.onClick}
          role={it.onClick ? "button" : undefined}
          tabIndex={it.onClick ? 0 : undefined}
          onKeyDown={it.onClick ? (e) => (e.key === "Enter" || e.key === " ") && it.onClick() : undefined}
          title={it.onClick ? "Click to see the list" : undefined}
          sx={{
            minWidth: 0,
            ...(i > 0 && { borderLeft: "1px solid #E2E8F0", pl: 3 }),
            ...(it.onClick && {
              cursor: "pointer",
              borderRadius: "8px",
              mx: -0.75,
              px: 0.75,
              "&:hover": { backgroundColor: "#F1F5F9" },
              "&:hover .lt-value": { textDecoration: "underline" },
            }),
          }}
        >
          <Typography
            sx={{
              fontSize: "0.6rem",
              fontWeight: 700,
              letterSpacing: "0.03em",
              textTransform: "uppercase",
              color: "#64748B",
              whiteSpace: "nowrap",
              lineHeight: 1.3,
            }}
          >
            {it.label}
          </Typography>
          <Typography
            className="lt-value"
            sx={{
              fontSize: "0.84rem",
              fontWeight: 800,
              color: TONES[it.tone] || TONES.default,
              whiteSpace: "nowrap",
              lineHeight: 1.35,
            }}
          >
            {it.value}
          </Typography>
          {it.sub && (
            <Typography
              sx={{ fontSize: "0.68rem", color: "#64748B", whiteSpace: "nowrap", lineHeight: 1.3 }}
            >
              {it.sub}
            </Typography>
          )}
        </Box>
      ))}
      {note && (
        <Typography sx={{ fontSize: 12.5, color: "#64748B", alignSelf: "center" }}>{note}</Typography>
      )}
    </Box>
  );
}
